/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.gatewayGroup', [])
    .factory('gatewayGroupService', GatewayGroupService)
    .name;

/*@ngInject*/
function GatewayGroupService($http, $q) {

    var service = {
        deleteGatewayGroup: deleteGatewayGroup,
        getGatewayGroup: getGatewayGroup,
        getSystemGatewayGroup: getSystemGatewayGroup,
        saveGatewayGroup: saveGatewayGroup,
        getProviderGatewayGroups: getProviderGatewayGroups,
        getCustomerGatewayGroups: getCustomerGatewayGroups,
        assignGatewayGroupToCustomer: assignGatewayGroupToCustomer,
        unassignGatewayGroupFromCustomer: unassignGatewayGroupFromCustomer,
        saveAlarmRules: saveAlarmRules,
        getNsMqttsCertificate: getNsMqttsCertificate
    };

    return service;

    function getProviderGatewayGroups () {
        var deferred = $q.defer();
        $http.get('/api/provider/gatewayGroups', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getCustomerGatewayGroups (customerId) {
        var deferred = $q.defer();
        $http.get(`/api/customer/${customerId}/gatewayGroups`, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getGatewayGroup (gatewayGroupId) {
        var deferred = $q.defer();
        var url = '/api/gatewayGroup/' + gatewayGroupId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getSystemGatewayGroup(gatewayGroupId) {
        var deferred = $q.defer();
        var url = '/api/system/gatewayGroup/' + gatewayGroupId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveAlarmRules (gatewayGroupId, alarmRules) {
        var deferred = $q.defer();
        var url = `/api/gatewayGroup/${gatewayGroupId}/alarmRules`;
        $http.post(url, alarmRules).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveGatewayGroup (gatewayGroup) {
        var deferred = $q.defer();
        var url = '/api/gatewayGroup';
        $http.post(url, gatewayGroup).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteGatewayGroup (gatewayGroupId) {
        var deferred = $q.defer();
        var url = '/api/gatewayGroup/' + gatewayGroupId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function assignGatewayGroupToCustomer(customerId, gatewayGroupId) {
        var deferred = $q.defer();
        var url = `/api/customer/${customerId}/gatewayGroup/${gatewayGroupId}`;
        $http.post(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function unassignGatewayGroupFromCustomer(gatewayGroupId) {
        var deferred = $q.defer();
        var url = `/api/customer/gatewayGroup/${gatewayGroupId}`;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getNsMqttsCertificate() {
        var deferred = $q.defer();
        var url = `/api/gatewayGroup/mqttsCert`;

        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/gateway-group.service.js